<div class="container">
	<h1 class="mat-h1" *ngIf="params.size == 1">{{ params.headline }}</h1>
	<h2 class="mat-h2" *ngIf="params.size == 2">{{ params.headline }}</h2>
	<h3 class="mat-h3" *ngIf="params.size == 3">{{ params.headline }}</h3>
	<h4 class="mat-h4" *ngIf="params.size == 4">{{ params.headline }}</h4>
</div>
